export enum EvaluationMode {
  Regular = 'Regular',
  SpectralReflectance = 'SpectralReflectance'
}
